/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type HalfPeriod = 'FIRST_HALF' | 'SECOND_HALF';

export const HalfPeriod = {
    FirstHalf: 'FIRST_HALF' as HalfPeriod,
    SecondHalf: 'SECOND_HALF' as HalfPeriod
};

